export interface BarChartPoint {
  label: string;
  value: number;
}

export interface BarChartProps {
  points: readonly BarChartPoint[];
  /** Rendered height of the tallest bar, in pixels. */
  maxHeight?: number;
  /** Suffix used in each bar's accessible description. */
  unit?: string;
}

/**
 * Minimal column chart.
 *
 * Bars are scaled against the largest value rather than drawn at a fixed
 * pixel height, so the shape stays truthful as the data changes.
 */
export function BarChart({ points, maxHeight = 96, unit = 'pts' }: BarChartProps) {
  const peak = Math.max(...points.map((p) => p.value), 1);

  return (
    <div>
      <div className="flex items-end gap-2" style={{ height: maxHeight }}>
        {points.map((point) => (
          <div
            key={point.label}
            title={`${point.label}: ${point.value} ${unit}`}
            className="flex-1 rounded-t-[4px] bg-linear-to-t from-accent/35 to-accent transition-[height] duration-500"
            style={{ height: `${Math.max((point.value / peak) * 100, 6)}%` }}
          >
            <span className="sr-only">{`${point.label}: ${point.value} ${unit}`}</span>
          </div>
        ))}
      </div>
      <div className="mt-2 flex justify-between font-mono text-[11px] text-content-muted">
        {points.map((point) => (
          <span key={point.label}>{point.label}</span>
        ))}
      </div>
    </div>
  );
}
